import Hashtable from "../Collections/HashMap/Hashtable";
import { XoneDataObject } from "../core/XoneDataObject";
import CXoneNameValuePair from "../Utils/CXoneNameValuePair";
import StringUtils from "../Utils/StringUtils";
import { Utils } from "../Utils/Utils";
export default class ScriptContext {
    /**
     * Construye un contexto de colección.
     * @param HostCollection		Colección en cuyo contexto se ejecuta el script.
     */
    constructor(HostCollection) {
        /**
         *  Objeto en cuyo contexto se ejecuta el script
         */
        this.m_object = null;
        /**
         *  Colección en cuyo contexto se ejecuta el script
         */
        this.m_coll = null;
        if (HostCollection instanceof XoneDataObject) {
            this.m_object = HostCollection;
            this.m_coll = HostCollection.getOwnerCollection();
        }
        else
            this.m_coll = HostCollection;
        // K10090801:	Carga de includes locales en los nodos de acciones.
        this.m_lstLocalIncludes = new Array();
    }
    /**
     * @return		Devuelve el objeto en el cual se ejecuta el script al que se refiere este contexto.
     */
    getObjectHost() {
        return this.m_object;
    }
    /**
     * @return		Devuelve la colección en la cual se ejecuta el script al que se refiere este contexto.
     */
    getCollectionHost() {
        return this.m_coll;
    }
    // Lista con los nombres de ficheros include de este contexto
    // Devuelve la lista de includes locales.
    // K10090801:	Carga de includes locales en los nodos de acciones.
    // La lista no es de cadenas
    getLocalIncludes() {
        return this.m_lstLocalIncludes;
    }
    /**
     * A12081701: Mecanismo para pasar parámetros a un nodo de acción.
     * Setea un parámetro para el script cuyo contexto tenemos. Los parámetros se podrán usar dentro del script
     * como variables dentro del scope global.
     *
     * @param ParamName			Nombre del parámetro. No puede coincidir con ningún valor reservado.
     * @param ParamValue		Valor del parámetro. Cualquier cosa.
     */
    SetParam(ParamName, ParamValue) {
        if (this.m_lstParams == null)
            this.m_lstParams = new Hashtable();
        if (StringUtils.IsEmptyString(ParamName))
            return;
        if (ParamValue != null)
            this.m_lstParams.put(ParamName, ParamValue);
        else
            this.m_lstParams.delete(ParamName);
    }
    /**
     * A12081701: Mecanismo para pasar parámetros a un nodo de acción.
     * Expone la lista de parámetros para poder sacarlos y meterlos en el contexto.
     *
     * @return La lista de parámetros o NULL si no hay parámetros.
     */
    GetParams() {
        return this.m_lstParams;
    }
    /**
     * L02102015: Sobrecargar ExtracArguments para poder usar Actionode null
     * K13080701: La ejecución de scripts con argumentos a nivel de colección falta en algunos casos.
     * Dado un contexto de script y una lista de argumentos saca los nombres de parámetros del nodo y
     * coloca los argumentos en el contexto...
     *
     * @param Arguments
     */
    // public void ExtractArguments(Object[] Arguments) {
    //     ExtractArguments(null,Arguments);
    // }
    ExtractArguments(ActionNode, ...args) {
        if (!args)
            return;
        let xna = null;
        if (ActionNode != null)
            xna = ActionNode.SelectNodes("param");
        args.forEach((value, i) => {
            let strName = null;
            if (Array.isArray(value)) {
                this.ExtractArguments(ActionNode, ...value);
            }
            else {
                if (value instanceof CXoneNameValuePair) { // Vienen los dos
                    //let nvp = (CXoneNameValuePair)value;
                    strName = value.Name;
                    value = value.Value;
                } // Vienen los dos
                else { // Sacar del XML
                    if (xna != null && i < xna.count()) { // Tenemos valor
                        let xarg = xna.get(i);
                        // Sacar el nombre
                        strName = xarg.getAttrValue(Utils.PROP_ATTR_NAME);
                    } // Tenemos valor
                    if (StringUtils.IsEmptyString(strName))
                        strName = String.format("Param%d", i + 1);
                } // Sacar del XML	
                this.SetParam(strName, value);
            }
        }); // Puede haber más parámetros que valores
    }
}

//# sourceMappingURL=ScriptContext.js.map
